__turbopack_context__.v({
  "action": "Yc5FMG_action",
  "action--selected": "Yc5FMG_action--selected",
  "actions": "Yc5FMG_actions",
  "address": "Yc5FMG_address",
  "author-link": "Yc5FMG_author-link",
  "content": "Yc5FMG_content",
  "content-wrapper": "Yc5FMG_content-wrapper",
  "divider": "Yc5FMG_divider",
  "info": "Yc5FMG_info",
  "member": "Yc5FMG_member",
  "modal": "Yc5FMG_modal",
  "modal__buttons": "Yc5FMG_modal__buttons",
  "modal__close-button": "Yc5FMG_modal__close-button",
  "modal__content": "Yc5FMG_modal__content",
  "modal__footer": "Yc5FMG_modal__footer",
  "modal__header": "Yc5FMG_modal__header",
  "modal__wrapper": "Yc5FMG_modal__wrapper",
  "title": "Yc5FMG_title",
  "wrapper": "Yc5FMG_wrapper",
});
